import AnnotationsHandler from '..';
import { C11nEnv } from '../../interpreter/c11n-env';
import ParagraphUtils from '../../dynamic-content/util';

AnnotationsHandler.registerHandler('@PARAGRAPH', (paragraphName: string, c11nEnv: C11nEnv) => {
  return ParagraphUtils.processParagraph(paragraphName, c11nEnv);
});
